<template>
  <div class="guide-cmp">
    <div class="guide-cmp-left">
      <a-row class="guide-cmp-title">
        一体化开发、运维服务支持
      </a-row>
      <div class="tab-list">
        <div :class="[
          'tab-pane',
          { 'tab-active': curTab == 1 },
          { 'tab-active-line': curTab != 1 && curTab > 1 },
        ]" @click="curTab = 1">
          开发准备
        </div>
        <div :class="[
          'tab-pane',
          { 'tab-active': curTab == 2 },
          { 'tab-active-line': curTab != 2 && curTab > 2 },
        ]" @click="curTab = 2">
          开发全过程资料
        </div>
        <div :class="[
          'tab-pane',
          { 'tab-active': curTab == 3 },
          { 'tab-active-line': curTab != 3 && curTab > 3 },
        ]" @click="curTab = 3">
          运维和功能手册
        </div>
      </div>
    </div>
    <div class="guide-cmp-right">
      
      <div class="tab-content-wrap">
        <!-- 开发准备 -->
        <div class="tab-content" v-show="curTab == 1">
          <div class="right-picture">
            <img src="../../assets/imgs/develop-ready.jpg" alt="开发准备" @click="openLink(pageLinks.developReady)" />
          </div>
          <div class="left-text">
            <div class="left-text-title">开发准备</div>
            <div class="left-text-subtitle">面向开发人员提供产品开发从0到1入门方案：</div>
            <ul class="left-text-content">
              <li>开放平台架构、本站能力一览、开发技术要求</li>
              <li>环境搭建教程、快速开发示例</li>
              <li>代码版本管理、编码规范、最佳实践</li>
              <li>问题分析和开发调试快速入门教程</li>
            </ul>
            <a-button class="left-text-btn" @click="openLink(pageLinks.developReady)">
              了解更多
            </a-button>
          </div>
        </div>
        <!-- 开发全过程资料 -->
        <div class="tab-content" v-show="curTab == 2">
          <div class="right-picture">
            <div :class="['slider', 'mt-' + hoverIndex + 'x']">
              <img src="../../assets/imgs/security.jpg" v-if="hoverIndex == 1" alt="安全开发规范"
                @click="openLink(pageLinks.developInfo.security)" />
              <img src="../../assets/imgs/platform.jpg" v-if="hoverIndex == 2" alt="多平台多端开发"
                @click="openLink(pageLinks.developInfo.multifyPlatform)" />
              <img src="../../assets/imgs/open-api.jpg" v-if="hoverIndex == 3" alt="openApi"
                @click="openLink(pageLinks.developInfo.openApi)" />
            </div>
          </div>
          <div class="left-text">
            <ul class="left-text-2">
              <li :class="{ 'hover-style': hoverIndex == 1 }" @mouseenter="slidePicture(1)">
                <div>
                  <div class="left-text-title">安全开发规范</div>
                  <div class="left-text-content">开发路线千万条，安全规范第一条，开发必读规范！</div>
                </div>
                <a-button class="left-text-btn" @click="openLink(pageLinks.developInfo.security)">
                  了解更多
                </a-button>
              </li>
              <li :class="{ 'hover-style': hoverIndex == 2 }" @mouseenter="slidePicture(2)">
                <div>
                  <div class="left-text-title">多平台多端开发</div>
                  <div class="left-text-content">面向CTP技术平台、CMP移动平台、CIP集成平台、CAP应用平台、各应用模块提供对应技术文档，供开发按需查阅</div>
                </div>
                <a-button class="left-text-btn" @click="openLink(pageLinks.developInfo.multifyPlatform)">
                  了解更多
                </a-button>
              </li>
              <li :class="{ 'hover-style': hoverIndex == 3 }" @mouseenter="slidePicture(3)">
                <div>
                  <div class="left-text-title">Open API</div>
                  <div class="left-text-content">二次开发使用接口化模式，提供Restful API、零源码侵入动态接口、V5核心模块Java
                    Doc文档，保障大部分场景无需查阅源码也能完成定制功能</div>
                </div>
                <a-button class="left-text-btn" @click="openLink(pageLinks.developInfo.openApi)">
                  了解更多
                </a-button>
              </li>
            </ul>
          </div>
        </div>
        <!-- 运维和功能手册 -->
        <div class="tab-content" v-show="curTab == 3" @click="openLink(pageLinks.developInfo.devOpsDoc)">
          <div class="right-picture" @click="openLink(pageLinks.developInfo.devOpsDoc)">
            <img src="../../assets/imgs/project-manage.jpg" alt="运维和功能手册" />
          </div>
          <div class="left-text">
            <ul>
              <li class="mb-0">
                <div class="left-text-title"> 运维和功能手册 </div>
                <div class="left-text-subtitle"></div>
                <ul class="left-text-content">
                  <li>面向运维实施提供在线化的部署手册文档和常见问题资料，免去离线下载的困扰，同时方便运维快速全面提升环境运维能力；</li>
                  <li>提供各模块的产品功能常见问题和解决方案资料，用户可带着自己的问题快速找到解决方案。</li>
                </ul>
              </li>
              <a-button class="left-text-btn">
                了解更多
              </a-button>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "guide-cmp",
  data() {
    return {
      curTab: 1,
      preHoverIndex: 0,
      hoverIndex: 1,
      pageLinks: {
        developReady: 'https://open.seeyoncloud.com/v5devCTP/38/51.html', // 开发准备
        developInfo: {
          security: 'https://open.seeyoncloud.com/v5devCTP/38/95.html', // 安全开发规范
          multifyPlatform: 'https://open.seeyoncloud.com/v5devCTP/', // 多平台多端开发
          openApi: 'https://open.seeyoncloud.com/seeyonapi/', // OPEN API
          devOpsDoc: 'https://open.seeyoncloud.com/v5doc/', // 运维实施手册
        } // 开发全过程资料
      }
    };
  },
  methods: {
    slidePicture(index) {
      if (this.hoverIndex == index) {
        return;
      }
      this.hoverIndex = index;
    },
    openLink(url) {
      window.location.href = url;
    }
  },
};
</script>
<style scoped lang="scss">
.guide-cmp{
  margin-bottom: 20px;
  padding: 3.6vh 2%;
  margin-top: 3.5vh;
  background: rgba(255,255,255,0.8);
  box-shadow: 0px 0px 14px 0px rgba(0,122,255,0.04);
  display: flex;
  &-left{ 
    display: flex;
    flex-direction: column;
    width: 29%;
  }
  &-right{ 
    flex: 1;
    margin-left: 40px;
  }

}
.guide-cmp-title {
  margin-bottom: 40px;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #000000;
}

ul {
  list-style: none;
  padding-left: 0;
}

.tab-list {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  font-size: 20px;
  color: #333333;
  flex: 1;

  .tab-pane {
    position: relative;
    width: 100%;
    height: 66px;
    line-height: 66px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #d8d8d8;

    &.tab-active {
      background: #007aff;
      color: #fff;
      border: 1px solid #007aff;
    }
    & + .tab-pane { 
      margin-top: 26px;
    }
  }
}
.tab-content {
  text-align: center;
  overflow: hidden;
  display: flex;
}
.left-text {
  margin-left: 30px;
  flex: 1;
  display: inline-block;
  text-align: center;
  vertical-align: top;
  font-size: 16px;

  &-title {
    font-size: 32px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #333333;
  }

  &-subtitle {
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 14px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #000;
  }

  &-content {
    font-size: 12px;
    color: #666666;
    line-height: 28px;
    margin-bottom: 44px;
  }

  &-btn {
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    height: 32px;
    line-height: 32px;
    padding: 0 70px;
    color: #007AFF;
    border: 1px solid rgba(#007aff, 0.3);
    border-radius: 29px;
    font-size: 14px;
    background: rgba(0,122,255,0.04);

    &:hover {
      background: #007aff;
      color: #fff;
    }
  }

  &-2 {
    margin-bottom: 0;
    .left-text-title {
      font-size: 16px;
      text-align: left;
    }

    .left-text-content {
      text-align: left;
      margin-top: 4px;
      margin-bottom: 12px;
      line-height: 16px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      /* 限制显示的行数为3 */
      overflow: hidden;
    }

    .left-text-btn {
      height: 32px;
      line-height: 32px;
      padding: 0 70px;
      font-size: 14px;
      margin-bottom: 20px;
    }
    li:last-child .left-text-btn {
      margin-bottom: 0;
    }

    .hover-style {

      .left-text-title,
      .left-text-content {
        color: #007AFF;
      }

      .left-text-btn {
        background: #007AFF;
        color: #fff;
      }
    }
  }
}

.right-picture {
  width: 660px;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;

  .slider {
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    /* Firefox 4 */
    -webkit-transition: all 0.4s;
    /* Safari 和 Chrome */
    -o-transition: all 0.4s;
    /* Opera */
  }

  img {
    width: 100%;
  }
}

.v-tab-pane-content {
  text-align: left;
  opacity: 0.5;
  transition: opacity 0.4s;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0.53px;
  line-height: 40px;
}

@media screen and (max-width: 1808px) {  
  .guide-cmp-title{
    margin-bottom: 30px;
  }
  .guide-cmp-title,
  .left-text-title {
    font-size: 28px;
  }
  .tab-list .tab-pane{
    height: 54px;
    line-height: 54px;
  }
  .guide-cmp-right{
    margin-left: 30px;
  }
  .right-picture{
    width: 560px;
  }
  .left-text-content{
    margin-bottom: 36px;
    line-height: 24px;
  }
}
@media screen and (max-width: 1520px) {
  .guide-cmp-left {
    width: 26%;
  }
  .guide-cmp-title,
  .left-text-title {
    font-size: 22px;
  }
  .tab-list{
    font-size: 18px;
    .tab-pane{
      & + .tab-pane{
        margin-top: 20px;
      }
    }
  }
  .left-text-subtitle{
    font-size: 12px;
  }
  .left-text{
    margin-left: 20px;
  }
  .left-text-2{ 
    .left-text-title{
      font-size: 14px;
    }
    .left-text-content{
      margin-top: 2px;
      margin-bottom: 6px;
    }
    .left-text-btn{
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      margin-bottom: 10px;
    }
  }
  .right-picture{
    width: 520px;
  }
}

@media screen and (max-width: 1370px) {
  .guide-cmp-title,
  .left-text-title {
    font-size: 18px;
  }
  .left-text-subtitle{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .tab-list .tab-pane{
    height: 44px;
    line-height: 44px;
  }
  .right-picture{
    width: 450px;
  }
  .left-text-content{
    margin-bottom: 20px;
    line-height: 20px;
  }
}

@media screen and (max-width: 1240px) {
  .guide-cmp{
    flex-direction: column;
    margin-top: 40px;
    padding: 4%;
    &-left{
      width: 100%;
    }
  }
  .guide-cmp-title{
    font-size: 28px;
    margin-bottom: 20px;
  }
  .left-text-subtitle{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .tab-list{
    flex-direction: row;
    align-items: center;
    font-size: 16px;
     .tab-pane{
        height: 50px;
        line-height: 50px;
        & + .tab-pane{ 
          margin-top: 0;
        }
      }
  }
  .guide-cmp-right{
    margin-left: 0;
    margin-top: 30px;
  }
  .right-picture{
    width: 64%;
  }
  .left-text-content{
    margin-bottom: 30px;
    line-height: 30px;
  }
}
@media screen and (max-width: 600px) {
  .guide-cmp{
    margin-top: 20px;
    padding: 6% 4%;
  }
  .guide-cmp-title{
    font-size: 18px;
  }
  .tab-list{
     .tab-pane{
        height: 40px;
        line-height: 40px;
      }
  }
  .guide-cmp-right{
    margin-left: 0;
    margin-top: 30px;
  }
  .right-picture{
    width: 100%;
  }
  .left-text-content{
    margin-bottom: 20px;
    line-height: 20px;
  }
  .left-text{
    margin-left: 0;
    margin-top: 20px;
  }
  .tab-content{
    flex-direction: column;
  }
}

@media screen and (max-width: 400px) {
  .tab-pane {
    font-size: 12px;
  }

  .left-text li,.left-text .left-text-content {
    font-size: 12px;
  }
}
</style>